import { CLASSTING_API_URL } from '../../constants';
import { http } from '../../utils';

export const fetchGuardianContactNewsletter = ({ token }) => http.get(`${CLASSTING_API_URL}/v1/guardian_contact_newsletters`, {
  params: { token },
  headers: { Authorization: 'guest' },
});
